import React from "react";
import Image from "components/image";
import RichText from "components/rich-text";
import { isMobile } from "utils/device-detect";
import clsx from "clsx/lite";

const MobileComponent = ({ data }) => {
	const { content, imageUnder, sideImage, alternate = false } = data;

	return (
		<div className="main w-full m-auto my-24 md:w-3/5">
			<div className={clsx("flex", alternate && "flex-row-reverse")}>
				<div className={clsx("w-3/5 flex flex-col flex-wrap justify-center", alternate && "content-end justify-center")}>
					<div className={clsx(alternate && "text-right")}>
						<Image className="w-3/4 text-left" image={imageUnder} />
					</div>
				</div>
				<div className="w-2/5 -mt-12.5"><Image className="opacity-100" image={sideImage} /></div>
			</div>
			<div className="w-11/12 mx-auto my-5"><RichText value={content} /></div>
		</div>
	);
};

const DesktopComponent = ({ data }) => {
	const { content, imageUnder, sideImage, alternate = false } = data;

	return (
		<div className={clsx("hd-screen-max-width flex mx-auto mt-20 gap-x-8", alternate && "flex-row-reverse")}>
			<div className={clsx("w-1/2", !alternate && "pl-10")}>
				<div className="my-10"><RichText value={content} /></div>
				<div className="text-center">
					<div><Image className="w-[70%] mt-40" image={imageUnder} alt={imageUnder.alt} /></div>
				</div>
			</div>
			<div className="w-[30%] mx-auto text-center"><Image image={sideImage} alt={sideImage?.alt} /></div>
		</div>
	);
};

const ImagesWithText = ({ data }) => {
	return isMobile() ? <MobileComponent data={data} /> : <DesktopComponent data={data} />;
};

export default ImagesWithText;
